import React from 'react';
import PropTypes from 'prop-types';
import Confirm from '../../confirm';

const DragAndDrop = ({
  t,
  id,
  label,
  fields,
  handleDrop,
  hideConfirm,
  showConfirm,
  onRemoveMult,
  tempMulFiles,
  onChangeGroup,
  onRemoveCallbackMult,
}) => (
  <React.Fragment>
    <div
      className="boxs doc2upload before2"
      id="upload-docs-block"
    >
      <div id="filedrag" className="dis uploadText filedrag1">
        <h6 className="text-center drag">{t('Drag and Drop more files')}</h6>
        <div className="Uploadimg">
          <img
            src="/img/dragdropimg.svg"
            alt="dragdropimg"
            className="img-responsive center-block"
          />
        </div>
      </div>
      <div
        className="doc2upload before2 drag-area"
        onDragEnter={(e) => { e.preventDefault(); e.target.classList.add('drag-area_ondrag'); }}
        onDragOver={(e) => { e.preventDefault(); e.target.classList.add('drag-area_ondrag'); }}
        onDragLeave={(e) => { e.preventDefault(); e.target.classList.remove('drag-area_ondrag'); }}
        onDrop={(e) => { e.preventDefault(); e.target.classList.remove('drag-area_ondrag'); handleDrop(e); }}
      />
      <div className="input-wrp">
        <div>
          <div className="attach-file">
            {label && (<label htmlFor={id}>{label}</label>)}
            <input
              id={id}
              type="file"
              multiple
              onChange={onChangeGroup}
              className="input-file group-input file-input"
            />
          </div>
        </div>
        <Confirm
          show={showConfirm}
          cancelCallback={hideConfirm}
          successCallback={onRemoveCallbackMult}
        />
      </div>
    </div>
    <div className="files">
      {fields({ files: tempMulFiles, onRemove: onRemoveMult })}
    </div>
  </React.Fragment>
);

DragAndDrop.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  hideConfirm: PropTypes.func.isRequired,
  showConfirm: PropTypes.bool.isRequired,
  fields: PropTypes.func,
  onRemoveMult: PropTypes.func.isRequired,
  tempMulFiles: PropTypes.array.isRequired,
  onChangeGroup: PropTypes.func.isRequired,
  onRemoveCallbackMult: PropTypes.func.isRequired,
  handleDrop: PropTypes.func.isRequired,
};

export default DragAndDrop;



// WEBPACK FOOTER //
// ./src/components/form/dragAndDrop/DragAndDrop.jsx